import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
} from "react-router-dom";
import { Home } from "./Views/Home";
import { NotFound } from "./Views/NotFound";
import Admin from "./Views/Admin/Admin";
import RenamePdfs from "./Views/Admin/RenamePdfs";
import AuthRoute from "./Components/AuthRoute";
import Login from "./Views/Login/Login";
import CustomLoginCallback from "./Components/CustomLoginCallback";
import App from "./App";
import { RequireRole } from "./Components/RequireRole";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<Navigate to="/home" replace />} />

      {/* Public routes */}
      <Route path="login" element={<Login />} />
      <Route path="login/callback" element={<CustomLoginCallback />} />
      <Route path="*" element={<NotFound />} />

      {/* Auth-protected routes */}
      <Route element={<AuthRoute />}>
        <Route path="home" element={<Home />} />
        <Route element={<RequireRole allowAdmin />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/rename-pdfs" element={<RenamePdfs />} />
        </Route>
      </Route>
    </Route>
  )
);

export default router;
